<template>
  <div>
    <div class="ml-0">
      <template v-if="servicio">
        <b-button
          id="button-1"
          :variant="typeAlert"
          class="p-2"
          :href="urlReclamos"
          target="_blank"
        >
          Libro Reclamaciones <i class="fas fa-book"> </i>
        </b-button>

        <b-tooltip ref="tooltip" target="button-1" :variant="typeAlert">
          <strong class="h5">
            <b-badge variant="light ">
              {{ notificacionReclamos }}
            </b-badge>
          </strong>
          <span class="h6"> Reclamos sin atender </span>
        </b-tooltip>
      </template>
      <template v-else>
        <b-button
          variant="primary"
          block
          @click="modalService()"
          target="_blank"
          class="p-1"
        >
          Libro Reclamaciones
          <i class="fas fa-book"></i>
        </b-button>
      </template>
    </div>
    <b-modal v-model="modalServicio" size="lg">
      <template #modal-title>
        <b-row>
          <b-col cols="12">
            <div style="width: 725%">
              <div class="text-center">
                <b-alert show class="estilo"><h3>Hola !</h3></b-alert>
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- <h3>Hola !</h3> -->
      </template>
      <div>
        <b-card no-body class="overflow-hidden" style="max-width: 840px">
          <b-row no-gutters>
            <b-col md="6">
              <b-card-img
                style="height: 100%"
                src="https://www.omniumdigital.com/wp-content/uploads/2017/06/gestion-empresarial.jpg"
                alt="Image"
                class="rounded-0"
              ></b-card-img>
            </b-col>
            <b-col md="6">
              <b-card-body>
                <b-card-text>
                  <p style="text-align: justify">
                    La Ley 29571 de Defensa del Consumidor dice que toda empresa
                    o negocio debe contar con un LIBRO DE RECLAMACIONES.
                  </p>
                  <p style="text-align: justify">
                    Por ello ponemos a disposición de su empresa el LIBRO DE
                    RECLAMACIONES DIGITAL el cual puede contratarlo y activarlo
                    de manera inmediata; evitando sanciones y multas.
                  </p>
                  <p>
                    TELEMOVIL DATA SAC Soluciones Corporativas para Negocios
                  </p>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </div>
      <template slot="modal-footer">
        <b-button
          @click="cerrarServicio"
          style="
            background-color: #d5e6fa;
            color: #13549f;
            border-color: #d5e6fa;
          "
          >Cerrar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "botonReclamos",

  data() {
    return {
      validarServicio: [],
      servicio: true,
      modalServicio: false,
      soporte: false,
      notificacionReclamos: {},
      typeAlert: "success",
      active: "",
    };
  },
  computed: {
    urlReclamos() {
      let user = this.$store.getters.userData.username;
      let ruc = this.$store.getters.userData.idEmisor;
      var link = process.env.VUE_APP_API_URL === 
      "http://demofoapi2.facturaonline.pe/api/" ? 
      "http://demotelereclamos.telemovil.global?user=" + user + "&ruc=" + ruc : 
      "https://libro-reclamaciones.net?user=" + user + "&ruc=" + ruc;
          // : "https://libroreclamaciones.telemovil.global?user=" +
          //   user +
          //   "&ruc=" +
          //   ruc;
      return link;
    },
  },
  mounted() {
    this.ServicioRuc();
  },
  methods: {
    async ServicioRuc() {
      try {
        const response = await axios.post(
          process.env.VUE_APP_API_URL + "v2/cliente/servicios",
          {
            idEmisor: this.$store.getters.userData.idEmisor,
          }
        );
        this.validarServicio = response.data.data;
        let val = false;
        this.validarServicio.forEach(function (element) {
          if (element.Codigo == "LIBROREC") {
            val = true;
          }
        });
        this.servicio = val;

        if (val) {
          var route =
            process.env.VUE_APP_API_URL ===
            "http://demofoapi2.facturaonline.pe/api/"
              ? "http://209.182.217.14:7070/api/reclamos/totales?ruc="
              : "https://apireclamaciones.telemovil.global/api/reclamos/totales?ruc=";
          var ruc = this.$store.getters.userData.idEmisor;
          const notificaciones = await axios.get(route + ruc);
          this.notificacionReclamos = notificaciones.data.total_abiertos;
        }

        if (this.notificacionReclamos > 1) {
          this.typeAlert = "danger";
        }
      } catch (error) {
        console.log(error);
      }
    },

    modalService() {
      this.modalServicio = true;
    },
    cerrarServicio() {
      this.modalServicio = false;
    },
    soporteT() {
      this.soporte = true;
    },
  },
};
</script>

